import { palette } from 'src/styles/colors';
import styled from 'styled-components';

export const SlabCreamContainer = styled.div`
  padding: 4rem 2rem;
  margin: 0 0 8.5em !important;
  max-width: 100vw !important;
  background: ${palette.cream};
  position: relative;

  &::after {
    position: absolute;
    content: ' ';
    height: 6rem;
    width: 100%;
    top: -6em;
    left: 0em;
    background: ${palette.cream};
    clip-path: polygon(100% 0, 0% 100%, 100% 100%);
  }

  &::before {
    position: absolute;
    content: ' ';
    height: 6rem;
    width: 100%;
    bottom: -6em;
    left: 0em;
    background: ${palette.cream};
    clip-path: polygon(0 0, 0% 100%, 100% 0);
  }
`
